import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	/** Pagina principale */
	if (document.querySelector("body").id === "event-page") {
		endlessPaginate();
		import("../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const gallery_data = document.querySelector("#_gallery-section");
			if (gallery_data) {
				new MovieFreeGLightbox({
					selector: gallery_data.dataset.gallerySelector,
				});
			}
		});

		import("../common/pubdate.js");
		import("../common/video_player.js");

		/** Pagina foto */
	} else if (document.querySelector("body").id === "event-image-page") {
		import("../common/image_gallery.js").then((module) => {
			const MovieGLightbox = module.MovieGLightbox;
			const gallery_data = document.querySelector("#gallery");
			let url = `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`;
			if (gallery_data.dataset.qs) {
				url = `${url}?${gallery_data.dataset.qs}`;
			}
			const main_gallery = new MovieGLightbox({
				url: url,
				per_page: 24,
				selector: "#gallery > .gallery__cell",
			});

			for (const el of document.querySelectorAll("a._gallery_album")) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					let album_url = `/misc/immagini/${el.dataset.ct}/${el.dataset.id}/`;
					if (el.dataset.qs) {
						album_url = `${album_url}?${el.dataset.qs}`;
					}
					new MovieGLightbox({ url: album_url });
				});
			}
			endlessPaginate({
				onCompleted: (context, fragment) => {
					const endless_url = new URL(context.url, window.location.origin);
					const qs = endless_url.searchParams;
					const page = Number.parseInt(qs.get(context.key));
					main_gallery.fetchPage(page);
				},
			});
		});

		/** Pagina film/serie tv (solo festival) */
	} else if (document.querySelector("body").id === "event-movies-page") {
		import("../common/paginated_tooltip.js");

		/** Pagina nomination (solo eventi non festival) */
	} else if (document.querySelector("body").id === "event-nomination-page") {
		import("bootstrap/js/dist/dropdown");
		endlessPaginate();

		/** Pagina video */
	} else if (document.querySelector("body").id === "event-video-page") {
		import("../common/video_player.js");
		endlessPaginate();
	}
});
